export default __webpack_public_path__ + "static/media/206.fb57e366.png";